import { NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  MatCard,
  MatCardAvatar,
  MatCardContent,
  MatCardFooter,
  MatCardHeader,
  MatCardSubtitle,
  MatCardTitle,
} from '@angular/material/card';
import { MatChip } from '@angular/material/chips';
import { MatRipple } from '@angular/material/core';
import { MatDivider } from '@angular/material/divider';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { UtcToUserFormattedPipe } from '../../../core/pipes/utc-to-user-formatted.pipe';
import { IIcon } from '../../../pages/items/item-view/items-kanban/items-kanban.interface';
import { IItemBase } from '../../../pages/items/items.interface';
import { EItemType } from '../../../pages/settings/fields-field-sets/field-sets/field-sets.interface';
import { DueDateChipComponent } from '../due-date-chip/due-date-chip.component';
import { InlineDatePickerComponent } from '../inline-date-picker/inline-date-picker.component';
import { InlineItemPriorityComponent } from '../inline-item-priority/inline-item-priority.component';
import { InlineUserChipComponent } from '../inline-user-chip/inline-user-chip.component';
import { ItemPriorityComponent } from '../item-priority/item-priority.component';
import { EItemPriority } from '../item-priority/item-priority.interface';
import { TextAvatarComponent } from '../text-avatar/text-avatar.component';

export type TItemCardData = Pick<IItemBase, 'id' | 'key' | 'name' | 'createdAt' | 'boardId'> & {
  assigneeName?: string | null;
  itemCategory?: string | undefined | null;
  itemType?: EItemType | undefined;
  itemCategoryName?: string | null;
  itemTypeName?: string;
  dueDate: string | null;
  statusCategory?: string;
  titleIcon?: IIcon | null;
  boardId?: number | null;
  strikeCount?: number;
  priority?: EItemPriority | null;
};

@Component({
  imports: [
    MatCard,
    NgClass,
    UtcToUserFormattedPipe,
    MatCardSubtitle,
    MatCardTitle,
    MatCardHeader,
    MatTooltip,
    TranslateModule,
    MatCardFooter,
    MatRipple,
    NgIf,
    MatCardAvatar,
    MatIcon,
    MatDivider,
    MatCardContent,
    MatChip,
    DueDateChipComponent,
    InlineUserChipComponent,
    InlineItemPriorityComponent,
    ItemPriorityComponent,
    TextAvatarComponent,
    InlineDatePickerComponent,
  ],
  selector: 'app-item-card',
  styleUrl: './item-card.component.scss',
  templateUrl: './item-card.component.html',
})
export class ItemCardComponent {
  public icon: string | undefined;

  @Input() public isDataLoading = false;
  @Input({ required: true }) public item!: TItemCardData;

  @Output() cardClick: EventEmitter<void> = new EventEmitter();
  @Output() triggerRefreshData: EventEmitter<void> = new EventEmitter();

  public onCardClick(): void {
    if (this.isDataLoading) {
      return;
    }

    this.cardClick.emit();
  }

  public triggerRefresh(): void {
    this.triggerRefreshData.emit();
  }
}
